// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1L56a","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__OCcIQ"};